import { routes } from '@/app/routing/router'
import { TasksView } from './view'

const currentRoute = routes.tasks

const TasksRoute = {
  route: currentRoute,
  view: TasksView,
}

export { currentRoute, TasksRoute }
